import { observer } from 'mobx-react';

import { ErrorMessage } from '../../../app/shared/components/Input/ErrorMessages/ErrorMessages';
import Button from '../../ui/Button/Button';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalHeading } from '../../ui/Modal/Modal';
import PricelistForm from '../PricelistForm/PricelistForm';
import css from './PricelistFormModal.css';
import PricelistFormModalState from './PricelistFormModalState';

interface PricelistFormModalProps {
  state: PricelistFormModalState;
  trigger?: React.ReactNode;
}

const PricelistFormModal = observer(({ state, trigger }: PricelistFormModalProps) => {
  if (!trigger) {
    return <PricelistFormModalContent state={state} />;
  }

  return (
    <Modal isOpen={state.visible} onOpenChange={state.toggle}>
      {trigger}
      <PricelistFormModalContent state={state} />
    </Modal>
  );
});

export default PricelistFormModal;

interface PricelistFormModalContentProps {
  state: PricelistFormModalState;
}

const PricelistFormModalContent = observer(({ state }: PricelistFormModalContentProps) => {
  const { translation } = state;

  const handleFormSubmit = (event: React.SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    state.submit();
  };

  return (
    <ModalContent size="small" isDismissable={!state.isPending} isOpen={state.visible} onOpenChange={state.toggle}>
      <ModalHeader closeLabel={translation.closeLabel} isCloseDisabled={state.isPending}>
        <ModalHeading>{translation.heading}</ModalHeading>
      </ModalHeader>
      <form onSubmit={handleFormSubmit} noValidate>
        <ModalBody className={css.body}>
          <PricelistForm state={state.form} />
          {state.errorMessage && (
            <div role="alert" className={css.error}>
              <ErrorMessage error={state.errorMessage} />
            </div>
          )}
        </ModalBody>
        <ModalFooter className={css.footer}>
          <Button slot="close" theme="primary" variant="outline" isDisabled={state.isPending}>
            {translation.cancelLabel}
          </Button>
          <Button type="submit" theme="primary" variant="solid" isPending={state.isPending}>
            {state.isPending ? translation.submitPendingLabel : translation.submitLabel}
          </Button>
        </ModalFooter>
      </form>
    </ModalContent>
  );
});
